import React from "react"
import { Button } from "components"
import { useMediaQuery } from "react-responsive"
import { mapContainerStyles, mapIframeStyles } from "./_Styles";

export default function Content({ jobDetails }) {
  
  const htmlElm = jobDetails.Description
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` })
  const isMedScreen= useMediaQuery({ query: `(max-width: 1090px)` })

  const redirectToJobSite = url => {
    window.open(url, "_blank")
  }

  const renderGoogleMaps = address => {
    // TODO: Restrict API key
    const GOOGLE_API_KEY = "AIzaSyBMLStWfGTmXKTSRjlhOR3-i_Rbqgis6Ls"
    return (
      <div className={mapContainerStyles()}>
        <iframe
          className={mapIframeStyles()}
          width={isMobile ? "300" : "450"}
          height="400"
          loading="lazy"
          src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_API_KEY}&q=${address}`}
        ></iframe>
      </div>
    )
  }

  const formatDate = timestamp => {
    const date = new Date(timestamp)
    return `${date.getDate()} ${date.toLocaleString("en-us", {
      month: "long",
    })}, ${date.getFullYear()}`
  }

  const renderApplyNowBtn = url => {
    return (
      // TODO: HP-266
      <div className="flex justify-center jdmd:justify-start">
        <Button
          label="Login to Apply"
          type="submit"
          appearance="primary"
          size="wide"
          onClick={() => {
            redirectToJobSite(url)
          }}
        />
      </div>
    )
  }
let finalJobDescription = htmlElm.replace(/(\n\n\n+^[ A-Za-z0-9_@./'’‘’:#&+-]*$)/gm,"<b>$1</b>")
// var divElement = document.createElement('div');
// divElement.innerHTML = myString;

// loop through ALL DOM elements insidie the divElement
// var elements = divElement.getElementsByTagName("*");
// for (var i = 0; i < elements.length; i++) {
//     elements[i].removeAttribute('style');
//     if(elements[i].tagName==='font'){
//       elements[i].parentNode.removeChild(elements[i]);
//     }
// }


  const {
    ApplyUrl,
    City,
    State,
    DatePosted,
    AddressLine1 = "",
    PostalCode = "",
    Country = "",
  } = jobDetails;

  return (
    <section className="jdWrapper default-grid">
      <div className="col-start-1 col-end-12 jdmd:col-end-9 mt-5 jdmd:mt-0">
      {isMedScreen && renderApplyNowBtn(ApplyUrl)}
        <div dangerouslySetInnerHTML={{ __html: finalJobDescription}} className="job-description mb-5"/>
        {/* <div dangerouslySetInnerHTML={{ __html: divElement.innerHTML }} className="job-description"/> */}
        {renderApplyNowBtn(ApplyUrl)}
      </div>
      <div className="col-start-1 col-end-12 jdmd:col-start-9 jdmd:col-end-12">
        <div className="flex flex-col justify-end">
          <section className="default-grid job-details-right-details jdmd:mt-8">
            <div className="jdmd:col-span-full">
              {!isMedScreen && renderApplyNowBtn(ApplyUrl)}
            </div>
            <div className="col-start-1 col-end-5">Location</div>
            <div className="col-start-5 col-end-12 bold-subtitle">
              {`${City}, ${State}`}
            </div>
            {/* <div className="col-start-1 col-end-5">Job Type</div>
            <div className="col-start-5 col-end-12 bold-subtitle">
              PLACEHOLDER
            </div> */}
            <div className="col-start-1 col-end-5">Posted On</div>
            <div className="col-start-5 col-end-12 bold-subtitle">
              {formatDate(DatePosted)}
            </div>
            
          </section>
          <section className="default-grid jdmd:mt-8">
            <div className="mt-12 col-span-full">
            {renderGoogleMaps(
              `${AddressLine1} ${City}, ${State} ${PostalCode} ${Country}`
            )}
            </div>
            
          </section>
         
        </div>
      </div>
    </section>
  )
}
